import { component } from 'picoapp'
import { Splide } from '@splidejs/splide'

export default component((node) => {
  new Splide(node, {
    type: 'loop',
    autoWidth: true,
    focus: 'center',
    pagination: false,
    live: false,
  }).mount()
})
